import { render, staticRenderFns } from "./SignatureVerification.vue?vue&type=template&id=30c278dc"
import script from "./SignatureVerification.vue?vue&type=script&lang=js"
export * from "./SignatureVerification.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/group-registration.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports